import PropTypes from "prop-types";

const TaskCommentError = ({
  summary,
  detail,
  otherAction,
  handleOtherAction,
}) => {
  return (
    <div className="flex align-items-center comment-error">
      <i className={`pi pi-times-circle error__timer--icon`} />
      <div>
        <span className="summary">{summary}</span>
        <span className="detail">{detail}</span>
        {otherAction && (
          <span
            className="attachment__error--other"
            onClick={handleOtherAction}
          >
            {otherAction}
          </span>
        )}
      </div>
    </div>
  );
};
TaskCommentError.propTypes = {
  summary: PropTypes.string,
  detail: PropTypes.string,
  otherAction: PropTypes.string,
  handleOtherAction: PropTypes.func,
};

export default TaskCommentError;
